var initSwipers = function initSwipers() {
  // Select all collection carousels with class .collection-carousel__swiper
  var swipers = document.querySelectorAll('.collection-carousel__swiper');

  // Initialize each swiper instance
  swipers.forEach(function (swiperElement) {
    // Get the next sibling element (the scrollbar)
    var scrollbar = swiperElement.nextElementSibling;
    new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      scrollbar: {
        el: scrollbar,
        draggable: true
      },
      navigation: {
        nextEl: swiperElement.previousElementSibling.querySelector('.collection-carousel__button-next'),
        prevEl: swiperElement.previousElementSibling.querySelector('.collection-carousel__button-prev')
      },
      breakpoints: {
        768: {
          spaceBetween: 20,
          slidesPerView: 4
        }
      }
    });
  });
};
export { initSwipers };